var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { useState } from "react";
import DatePicker from "react-datepicker";
import { FormattedDate, FormattedMessage, useIntl } from "react-intl";
export default function DateRange(props) {
    var intl = useIntl();
    var _a = useState(props.startDate ? props.startDate : new Date()), startDate = _a[0], setStartDate = _a[1];
    var _b = useState(props.endDate), endDate = _b[0], setEndDate = _b[1];
    useEffect(function () {
        setStartDate(props.startDate);
        setEndDate(props.endDate);
    }, [props.startDate, props.endDate]);
    var onSetStartDate = function (date) {
        setStartDate(date);
        if (date > endDate) {
            setEndDate(date);
        }
        if (props.onChange) {
            props.onChange([startDate, endDate]);
        }
    };
    var onSetEndDate = function (date) {
        setEndDate(date);
        if (props.onChange) {
            props.onChange([startDate, endDate]);
        }
    };
    var sharedProps = {
        locale: 'nl',
        inline: true,
        timeFormat: 'HH:mm',
        previousMonthButtonLabel: intl.formatMessage({ id: 'datepicker.month.previous' }),
        nextMonthButtonLabel: intl.formatMessage({ id: 'datepicker.month.next' }),
        startDate: startDate,
        endDate: endDate
    };
    return React.createElement("div", { className: "d-flex flex-column flex-md-row" },
        React.createElement("div", { className: "d-flex flex-column mr-2" },
            React.createElement("label", { className: "font-weight-bold" },
                React.createElement(FormattedMessage, { id: "daterange.label.startdate" }),
                " (",
                React.createElement(FormattedDate, { value: startDate }),
                ")"),
            React.createElement(DatePicker, __assign({ calendarClassName: "react-datepicker--inline", selected: startDate, onChange: onSetStartDate, selectsStart: true }, sharedProps))),
        React.createElement("div", { className: "d-flex flex-column ml-2" },
            React.createElement("label", { className: "font-weight-bold" },
                React.createElement(FormattedMessage, { id: "daterange.label.enddate" }),
                " (",
                React.createElement(FormattedDate, { value: endDate }),
                ")"),
            React.createElement(DatePicker, __assign({ calendarClassName: "react-datepicker--inline", selected: endDate, onChange: onSetEndDate, minDate: startDate, selectsEnd: true }, sharedProps))));
}
